const getApplicationMode = () => {
    return 'production';
};

const getBaseUrl = () => {
    const applicationMode = getApplicationMode();
    return applicationMode === "production"
        ? "https://kikoapi.smartkos.com"
        : "http://localhost:4020";
};

const getApiBaseUrl = () => {
    const baseUrl = getBaseUrl();
    return `${baseUrl}/v1`;
};

export { getBaseUrl, getApiBaseUrl, getApplicationMode };
